import React, { forwardRef } from 'react';
import getIsInMicrosoft from 'helpers/getIsInMicrosoft';

interface Props extends React.ComponentProps<'a'> {
  children: React.ReactNode;
  href: string;
}

const NewTabATag = forwardRef((props: Props, ref: React.Ref<any>) => {
  const isInMicrosoft = getIsInMicrosoft();

  const { children, ...restOfProps } = props;
  const stayInTheSameTab = isInMicrosoft && props.href.startsWith('/');

  return (
    <>
      {stayInTheSameTab ? (
        <a {...restOfProps} ref={ref}>
          {children}
        </a>
      ) : (
        <a {...restOfProps} target="_blank" rel="noreferrer noopener" ref={ref}>
          {children}
        </a>
      )}
    </>
  );
});

export default NewTabATag;
